var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.step === 1
        ? _c("OnboardingPage", {
            on: { mandateTypeSelected: _vm.handleMandateTypeSelected }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.step === 2
        ? _c("OnboardingCompanyPage", {
            attrs: { selectedMandateType: _vm.selectedMandateType },
            on: { companySelected: _vm.handleCompanySelected }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.step === 3
        ? _c("OnboardingElectronicAddressPage", {
            attrs: { siren: _vm.company.siren.value },
            on: { addressSelected: _vm.handleAddressSelected }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.step === 4
        ? _c("OnboardingLegalRepresentativePage", {
            on: { validate: _vm.handleLegalRepresentativeValidation }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }